import * as Yup from 'yup';

export const LogComplaintSchema = Yup.object().shape({
  verificationIssueLog: Yup.string().required('Complaint is required'),
});

export interface LogComplaintDataType {
  verificationIssueLog: string;
}

export const LogComplaintInitialValues: LogComplaintDataType =
{
  verificationIssueLog: '',
};

export interface LogComplaintInterface {
  verificationIssueLog: string;
}
